<template>
  <div class="contain">
    <!-- 검색 영역 -->
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :model="searchForm"
        :label-position="{ tablet: 'top' }[$device.currentSize] ?? 'left'"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :sm="6">
            <el-form-item :label="$t('핸드폰 번호')">
              <el-input v-model="searchForm.tel" @keyup.enter.native="searchFirstPage" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="6">
            <el-form-item :label="$t('이름')">
              <el-input v-model="searchForm.name" @keyup.enter.native="searchFirstPage" clearable></el-input>
            </el-form-item>
          </el-col>
          <!--          <el-col :sm="6">-->
          <!--            <el-form-item :label="$t('사용 가능 여부')">-->
          <!--              <combo-->
          <!--                :data="mainVue.code.useYn"-->
          <!--                :label="$t('전체')"-->
          <!--                :model="searchForm.useYn"-->
          <!--                @change="searchForm.useYn = $event"></combo>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->
        </el-row>
      </el-form>
    </div>

    <!-- 버튼 -->
    <div class="buttons" ref="buttons" style="display: flex; align-items: center">
      <el-button
        v-if="checkAuthActionAccess('TelInfoForStoreSearch')"
        :size="size"
        @click="searchFirstPage"
        icon="el-icon-search"
        >{{ $t('검색') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('TelInfoForStoreAdd')"
        :size="size"
        @click="add"
        icon="el-icon-circle-plus-outline"
        :disabled="btn.addDisabled"
        >{{ $t('등록') }}</el-button
      >
      <!-- 요청 문구(V5) — 액션이 있을 때만. 목록 진입에는 새 조회가 없다(누를 때 한 번 읽는다) -->
      <el-button v-if="canReadPhrases" :size="size" @click="openPhraseDialog" icon="el-icon-chat-line-square">{{
        $t(T.phrasesButton)
      }}</el-button>
      <!-- 고객 가져오기(설계 「주문 고객 → 고객 가져오기」) — 그 화면의 게이트 액션이 있을 때만 -->
      <el-button v-if="canImport" :size="size" @click="$router.push(importPath)" icon="el-icon-upload2">{{
        $t(T.importButton)
      }}</el-button>
      <el-button
        :size="size"
        @click="openBulkCouponDialog"
        icon="el-icon-message"
        type="primary"
        :disabled="totalElements === 0"
        style="margin-left: auto"
        >{{ $t('일괄 쿠폰 발송') }}</el-button
      >
      <!--      <el-button-->
      <!--        v-if="checkAuthActionAccess('TelInfoForStoreDel')"-->
      <!--        :size="size"-->
      <!--        @click="del"-->
      <!--        icon="el-icon-remove-outline"-->
      <!--        :disabled="btn.delDisabled"-->
      <!--        >{{ $t('삭제') }}</el-button-->
      <!--      >-->
    </div>

    <!-- 리스트 -->
    <el-table
      :height="tableHeight"
      ref="table"
      border
      stripe
      highlight-current-row
      tooltip-effect="dark"
      :data="tableData"
      :size="size"
      :empty-text="$t('데이타 없음')"
      :default-sort="{ prop: 'lastTelDate', order: 'descending' }"
      @row-click="handleRowClick"
      @select="handleRowChecked"
      @select-all="handleRowChecked"
      @sort-change="handleSortChange">
      <el-table-column
        :label="totalElements.toString()"
        type="index"
        width="55"
        align="center"
        fixed
        label-class-name="data_cnt"
        :index="indexMethod"></el-table-column>
      <!--      <el-table-column type="selection" width="45" align="center" :fixed="!$device.mobile"></el-table-column>-->
      <!-- 정렬은 **서버**가 한다(`sortable="custom"`) — 페이징된 목록에서 `sortable` 은 「이 페이지 안에서만」이라
           머리글이 가리키는 순서와 서버가 고른 한 장이 서로 다른 말을 한다. 열의 `prop` 이 곧 `sortProp` 이다 -->
      <el-table-column :label="$t('핸드폰 번호')" prop="tel" min-width="130" align="center" sortable="custom">
        <template slot-scope="scope">
          <el-button type="text" @click="clickUp(scope.row)">
            <i class="el-icon-edit-outline"></i>&nbsp;{{ telText(scope.row.tel) }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('이름')"
        prop="name"
        min-width="120"
        align="center"
        sortable="custom"></el-table-column>
      <!-- 보이는 값은 화면이 만든 합(`totalOrderCntDesc`)이고 **정렬 축은 서버 컬럼**(`totalOrderCnt`)이다.
           `sort-change` 가 내보내는 이름이 곧 열의 `prop` 이라 여기엔 서버가 아는 이름을 적고 표시는 포매터가
           맡는다 — 화면 이름과 서버 이름을 잇는 매핑 표를 따로 두지 않는다 -->
      <el-table-column
        :label="$t('주문 횟수')"
        prop="totalOrderCnt"
        min-width="80"
        align="center"
        sortable="custom"
        :formatter="formatTotalOrderCnt"></el-table-column>
      <el-table-column
        :label="$t('마지막 주문 일자')"
        prop="lastTelDate"
        min-width="140"
        align="center"
        sortable="custom"></el-table-column>

      <el-table-column
        :label="$t('메모')"
        prop="lastShopMemo"
        min-width="140"
        align="center"
        sortable="custom"></el-table-column>

      <!-- 셀은 날짜 유무를 동의/미동의로 읽지만 정렬 축은 그 날짜다 — `prop` 없이 `sortable` 만 두면
           서버로 보낼 축이 없어 눌러도 아무 일이 없다(화이트리스트에 있는 이름이다) -->
      <el-table-column
        :label="$t('마케팅 동의')"
        prop="marketingAgreeDate"
        min-width="100"
        align="center"
        sortable="custom">
        <template slot-scope="scope">
          {{ scope.row.marketingAgreeDate ? '동의' : '미동의' }}
        </template>
      </el-table-column>

      <el-table-column :label="$t('쿠폰 보내기')" min-width="120" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="openCouponDialog(scope.row)"
            icon="el-icon-message"
            :disabled="!scope.row.marketingAgreeDate">
            {{ $t('쿠폰 보내기') }}
          </el-button>
        </template>
      </el-table-column>

      <!--      <el-table-column-->
      <!--          :label="$t('오더톡 주문 횟수')"-->
      <!--          prop="orderCnt"-->
      <!--          min-width="140"-->
      <!--          align="right"-->
      <!--          sortable></el-table-column>-->
      <!--      <el-table-column-->
      <!--        :label="$t('전화 주문 수량')"-->
      <!--        prop="telOrderCnt"-->
      <!--        min-width="140"-->
      <!--        align="right"-->
      <!--        sortable></el-table-column>-->
      <!--      <el-table-column-->
      <!--        :label="$t('사용 가능 여부')"-->
      <!--        prop="useYn"-->
      <!--        min-width="100"-->
      <!--        align="center"-->
      <!--        :formatter="mainVue.formatterCode"></el-table-column>-->
    </el-table>

    <list-pagination
      :search-form="searchForm"
      :total="totalElements"
      :page-sizes="[30, 50, 100]"
      @page-change="handlePageChange"
      @size-change="handleSizeChange"></list-pagination>

    <!-- 입력 팝업 -->
    <el-dialog :title="inputForm.title" :visible.sync="dialogFormVisible" fullscreen>
      <el-form
        :model="inputForm"
        :label-width="$device.mobile ? `` : `180px`"
        :label-position="$device.mobile ? `top` : ''"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :md="12">
            <el-form-item :label="$t('핸드폰 번호')" :error="formError.tel" required>
              <el-input
                v-if="'I' === inputForm.statu"
                v-keep-number-caret
                :value="util.telFieldText(inputForm.tel)"
                maxlength="50"
                clearable
                show-word-limit
                @input="inputForm.tel = util.telDigits($event)"></el-input>
              <span v-else class="show_cd">{{ telText(inputForm.tel) }}</span>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('이름')" :error="formError.name">
              <el-input v-model="inputForm.name" :maxlength="limits.name" clearable show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('오더톡 주문 횟수')" :error="formError.orderCnt">
              <el-input-number v-model="inputForm.orderCnt" :min="0"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('전화 주문 횟수')" :error="formError.telOrderCnt">
              <el-input-number v-model="inputForm.telOrderCnt" :min="0"></el-input-number>
            </el-form-item>
          </el-col>
          <!-- 쓰던 프로그램의 이전 값(가져온 고객) — 읽기 전용, 오더엔 주문 수와 섞지 않는다 -->
          <el-col v-if="priorLine" :md="24">
            <el-form-item>
              <span class="tel-info__prior">{{ priorLine }}</span>
            </el-form-item>
          </el-col>
          <el-col :md="24">
            <el-form-item :label="$t('고객 메모')" :error="formError.lastShopMemo">
              <el-input
                type="textarea"
                :rows="3"
                :placeholder="$t(T.memoPlaceholder)"
                v-model="inputForm.lastShopMemo"
                :maxlength="limits.memo"
                show-word-limit></el-input>
              <!-- 칸 아래 늘 보이는 줄 — 메모가 있으면 placeholder 가 안 보이므로 안내를 거기에만 두지 않는다(결정 27) -->
              <p class="tel-info__notice">{{ $t(T.memoNotice) }}</p>
            </el-form-item>
          </el-col>
          <!--
            취향(결정 21) — 매장 주방 요청 문구에서만 고른다(`allow-create` 없음). 수정 창에만 있다: 추가(`POST /telInfo`)는 취향을
            받지 않는다. 요청 문구를 못 읽었으면 그리지 않는다 — 값은 그대로이고 바뀐 칸 본문에도 실리지 않는다.
          -->
          <el-col v-if="showPrefs" :md="24">
            <el-form-item :label="$t(T.prefLabel)" :error="formError.prefTags">
              <el-select
                v-model="inputForm.prefTags"
                class="tel-info__prefs"
                multiple
                :placeholder="$t(T.prefPlaceholder)">
                <el-option
                  v-for="option in prefOptions"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"></el-option>
              </el-select>
              <p class="tel-info__notice">
                {{ $t(T.prefHelp) }}
                <el-button v-if="canEditPhrases" type="text" size="mini" @click="openPhraseDialog">{{
                  $t(T.editPhrases)
                }}</el-button>
              </p>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('마케팅 동의')">
              <el-switch
                v-model="inputForm.marketingAgree"
                :active-text="$t('동의')"
                :inactive-text="$t('미동의')"
                @change="onMarketingAgreeChange">
              </el-switch>
            </el-form-item>
          </el-col>
          <!--          <el-col :md="12">-->
          <!--            <el-form-item :label="$t('사용 가능 여부')" required>-->
          <!--              <combo :data="mainVue.code.useYn" :model="inputForm.useYn" @change="inputForm.useYn = $event"></combo>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->
        </el-row>
      </el-form>
      <!-- 주소록(V6) — 기존 고객의 수정 창에서만, 창을 열 때 읽는다(액션이 있을 때만) -->
      <TelInfoAddressBook
        v-if="dialogFormVisible && editing && canListAddresses"
        :key="inputForm.seq"
        :tel-info-seq="inputForm.seq"
        :rider-phrases="phrases ? phrases.rider : null"
        :can-edit="canEditAddresses" />
      <div slot="footer" class="dialog-footer">
        <el-button :size="size" @click="save" icon="el-icon-check" :disabled="btn.saveDisabled">{{
          $t('저장')
        }}</el-button>
        <el-button :size="size" @click="dialogFormVisible = false" icon="el-icon-close">{{ $t('닫기') }}</el-button>
      </div>
    </el-dialog>

    <!-- 쿠폰 발송 팝업 -->
    <el-dialog
      title="쿠폰 발송"
      :visible.sync="couponDialogVisible"
      :width="$device.mobile ? '95%' : '600px'"
      :modal="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false">
      <div class="coupon-dialog-content">
        <div class="customer-info-section">
          <h4>{{ selectedCustomer.name || '고객' }}님에게 쿠폰을 발송합니다.</h4>

          <div class="customer-details">
            <p><strong>고객 정보</strong></p>
            <ul>
              <li>전화번호: {{ telText(selectedCustomer.tel) }}</li>
              <li v-if="selectedCustomer.name">이름: {{ selectedCustomer.name }}</li>
              <li>주문 횟수: {{ selectedCustomer.totalOrderCntDesc }}회</li>
            </ul>
          </div>
        </div>

        <el-form
          :model="couponForm"
          :label-width="$device.mobile ? '100%' : '120px'"
          :label-position="$device.mobile ? 'top' : 'left'"
          :size="size">
          <el-form-item label="쿠폰명" required>
            <el-select
              v-model="couponForm.selectedDiscountCd"
              placeholder="발송할 쿠폰을 선택하세요"
              style="width: 100%"
              :disabled="!(discountList && discountList.length)"
              @change="onDiscountChange">
              <el-option
                v-for="discount in discountList"
                :key="discount.discountCd"
                :label="discount.discountNmLan"
                :value="discount.discountCd">
              </el-option>
            </el-select>
            <p v-if="discountNote" class="tel-info__notice coupon-discount-note">{{ $t(discountNote) }}</p>
          </el-form-item>

          <!-- 선택된 쿠폰 상세 정보 -->
          <div v-if="couponForm.selectedDiscount" class="coupon-details-section">
            <div class="details-header">
              <h4><i class="el-icon-tickets"></i> 쿠폰 상세 정보</h4>
            </div>
            <div class="details-content">
              <el-row :gutter="$device.mobile ? 0 : 20">
                <el-col :span="$device.mobile ? 24 : 12">
                  <div class="detail-item">
                    <span class="detail-label">할인 대상:</span>
                    <span class="detail-value">{{ couponForm.selectedDiscount.discountTarget?.nmLan || '-' }}</span>
                  </div>
                </el-col>
                <el-col :span="$device.mobile ? 24 : 12">
                  <div class="detail-item">
                    <span class="detail-label">할인 유형:</span>
                    <span class="detail-value">{{ couponForm.selectedDiscount.discountTp?.nmLan || '-' }}</span>
                  </div>
                </el-col>
                <el-col :span="$device.mobile ? 24 : 12">
                  <div class="detail-item">
                    <span class="detail-label">할인 금액/율:</span>
                    <span class="detail-value discount-amount">
                      <template v-if="couponForm.selectedDiscount.discountTp?.val === 'price'">
                        {{ mainVue.formatterPrice(null, null, couponForm.selectedDiscount.price) }}원
                      </template>
                      <template v-else-if="couponForm.selectedDiscount.discountTp?.val === 'percent'">
                        {{ couponForm.selectedDiscount.percente }}%
                      </template>
                      <template v-else>-</template>
                    </span>
                  </div>
                </el-col>
                <el-col :span="$device.mobile ? 24 : 12">
                  <div class="detail-item">
                    <span class="detail-label">판매 방식:</span>
                    <span class="detail-value">{{ couponForm.selectedDiscount.salesTpNms || '-' }}</span>
                  </div>
                </el-col>
                <el-col :span="24" v-if="couponForm.selectedDiscount.discountDesc">
                  <div class="detail-item">
                    <span class="detail-label">설명:</span>
                    <span class="detail-value">{{ couponForm.selectedDiscount.discountDesc }}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>

          <el-form-item label="메뉴 선택" required v-if="isMenuDiscount(couponForm.selectedDiscount)">
            <el-select
              v-model="couponForm.selectedMenuCd"
              placeholder="적용할 메뉴를 선택하세요"
              style="width: 100%"
              :disabled="!menuList.length"
              @change="onMenuChange">
              <el-option v-for="menu in menuList" :key="menu.smenuCd" :label="menu.smenuNmLan" :value="menu.smenuCd">
              </el-option>
            </el-select>
          </el-form-item>

          <!-- 선택된 메뉴 상세 정보 -->
          <div
            v-if="couponForm.selectedMenu && isMenuDiscount(couponForm.selectedDiscount)"
            class="menu-details-section">
            <div class="details-header">
              <h4><i class="el-icon-food"></i> 선택된 메뉴 정보</h4>
            </div>
            <div class="details-content">
              <el-row :gutter="$device.mobile ? 0 : 20">
                <el-col :span="$device.mobile ? 24 : 12">
                  <div class="detail-item">
                    <span class="detail-label">메뉴명:</span>
                    <span class="detail-value">{{ couponForm.selectedMenu.smenuNmLan }}</span>
                  </div>
                </el-col>
                <el-col :span="$device.mobile ? 24 : 12">
                  <div class="detail-item">
                    <span class="detail-label">기본 가격:</span>
                    <span class="detail-value menu-price original-price"
                      >{{ mainVue.formatterPrice(null, null, couponForm.selectedMenu.priceLan) }}원</span
                    >
                  </div>
                </el-col>
                <el-col :span="24" v-if="couponForm.selectedMenu.smenuDesc">
                  <div class="detail-item">
                    <span class="detail-label">설명:</span>
                    <span class="detail-value">{{ couponForm.selectedMenu.smenuDesc }}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>

          <el-form-item label="유효기간" required>
            <el-select v-model="couponForm.validityPeriod" placeholder="유효기간을 선택하세요" style="width: 100%">
              <el-option
                v-for="period in validityOptions"
                :key="period.value"
                :label="period.label"
                :value="period.value">
              </el-option>
            </el-select>
          </el-form-item>

          <!-- 유효기간 상세 정보 -->
          <div v-if="couponForm.validityPeriod" class="validity-details-section">
            <div class="details-header">
              <h4><i class="el-icon-time"></i> 유효기간 상세</h4>
            </div>
            <div class="details-content">
              <el-row :gutter="$device.mobile ? 0 : 20">
                <el-col :span="$device.mobile ? 24 : 12">
                  <div class="detail-item">
                    <span class="detail-label">발송일:</span>
                    <span class="detail-value">{{ couponForm.sendDate }}</span>
                  </div>
                </el-col>
                <el-col :span="$device.mobile ? 24 : 12">
                  <div class="detail-item">
                    <span class="detail-label">만료일:</span>
                    <span class="detail-value expiry-date">{{
                      getExpiryDate(couponForm.validityPeriod, couponForm.sendDate)
                    }}</span>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="detail-item">
                    <span class="detail-label">안내:</span>
                    <span class="detail-value validity-notice">
                      <template v-if="couponForm.validityPeriod === 1">
                        쿠폰은 오늘 23:59까지 사용 가능합니다.
                      </template>
                      <template v-else>
                        쿠폰은 발송일로부터 {{ couponForm.validityPeriod }}일간 사용 가능하며, 만료일
                        {{ getExpiryDate(couponForm.validityPeriod, couponForm.sendDate) }} 23:59까지 유효합니다.
                      </template>
                    </span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button :size="size" @click="couponDialogVisible = false">취소</el-button>
        <el-button
          :size="size"
          type="primary"
          @click="sendCoupon"
          :disabled="
            !couponForm.selectedDiscount ||
            !couponForm.validityPeriod ||
            (isMenuDiscount(couponForm.selectedDiscount) && !couponForm.selectedMenuCd)
          ">
          쿠폰 발송
        </el-button>
      </div>
    </el-dialog>

    <!-- 일괄 쿠폰 발송 팝업 -->
    <el-dialog
      title="일괄 쿠폰 발송"
      :visible.sync="bulkCouponDialogVisible"
      :width="$device.mobile ? '95%' : '600px'"
      :modal="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false">
      <div class="coupon-dialog-content">
        <div class="customer-info-section">
          <h4>
            총 {{ totalElements }}명의 고객 중 마케팅 동의한 {{ totalMarketingConsentCount }}명에게 일괄 발송합니다.
          </h4>

          <div class="customer-details">
            <p><strong>발송 대상</strong></p>
            <ul>
              <li>마케팅 동의 고객: {{ totalMarketingConsentCount }}명</li>
            </ul>
          </div>
        </div>

        <el-form
          :model="bulkCouponForm"
          :label-width="$device.mobile ? '100%' : '120px'"
          :label-position="$device.mobile ? 'top' : 'left'"
          :size="size">
          <el-form-item label="쿠폰명" required>
            <el-select
              v-model="bulkCouponForm.selectedDiscountCd"
              placeholder="발송할 쿠폰을 선택하세요"
              style="width: 100%"
              :disabled="!(discountList && discountList.length)"
              @change="onBulkDiscountChange">
              <el-option
                v-for="discount in discountList"
                :key="discount.discountCd"
                :label="discount.discountNmLan"
                :value="discount.discountCd">
              </el-option>
            </el-select>
            <p v-if="discountNote" class="tel-info__notice coupon-discount-note">{{ $t(discountNote) }}</p>
          </el-form-item>

          <!-- 선택된 쿠폰 상세 정보 -->
          <div v-if="bulkCouponForm.selectedDiscount" class="coupon-details-section">
            <div class="details-header">
              <h4><i class="el-icon-tickets"></i> 쿠폰 상세 정보</h4>
            </div>
            <div class="details-content">
              <el-row :gutter="$device.mobile ? 0 : 20">
                <el-col :span="$device.mobile ? 24 : 12">
                  <div class="detail-item">
                    <span class="detail-label">할인 대상:</span>
                    <span class="detail-value">{{ bulkCouponForm.selectedDiscount.discountTarget?.nmLan || '-' }}</span>
                  </div>
                </el-col>
                <el-col :span="$device.mobile ? 24 : 12">
                  <div class="detail-item">
                    <span class="detail-label">할인 유형:</span>
                    <span class="detail-value">{{ bulkCouponForm.selectedDiscount.discountTp?.nmLan || '-' }}</span>
                  </div>
                </el-col>
                <el-col :span="$device.mobile ? 24 : 12">
                  <div class="detail-item">
                    <span class="detail-label">할인 금액/율:</span>
                    <span class="detail-value discount-amount">
                      <template v-if="bulkCouponForm.selectedDiscount.discountTp?.val === 'price'">
                        {{ mainVue.formatterPrice(null, null, bulkCouponForm.selectedDiscount.price) }}원
                      </template>
                      <template v-else-if="bulkCouponForm.selectedDiscount.discountTp?.val === 'percent'">
                        {{ bulkCouponForm.selectedDiscount.percente }}%
                      </template>
                      <template v-else>-</template>
                    </span>
                  </div>
                </el-col>
                <el-col :span="$device.mobile ? 24 : 12">
                  <div class="detail-item">
                    <span class="detail-label">판매 방식:</span>
                    <span class="detail-value">{{ bulkCouponForm.selectedDiscount.salesTpNms || '-' }}</span>
                  </div>
                </el-col>
                <el-col :span="24" v-if="bulkCouponForm.selectedDiscount.discountDesc">
                  <div class="detail-item">
                    <span class="detail-label">설명:</span>
                    <span class="detail-value">{{ bulkCouponForm.selectedDiscount.discountDesc }}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>

          <el-form-item label="메뉴 선택" required v-if="isMenuDiscount(bulkCouponForm.selectedDiscount)">
            <el-select
              v-model="bulkCouponForm.selectedMenuCd"
              placeholder="적용할 메뉴를 선택하세요"
              style="width: 100%"
              :disabled="!menuList.length"
              @change="onBulkMenuChange">
              <el-option v-for="menu in menuList" :key="menu.smenuCd" :label="menu.smenuNmLan" :value="menu.smenuCd">
              </el-option>
            </el-select>
          </el-form-item>

          <!-- 선택된 메뉴 상세 정보 -->
          <div
            v-if="bulkCouponForm.selectedMenu && isMenuDiscount(bulkCouponForm.selectedDiscount)"
            class="menu-details-section">
            <div class="details-header">
              <h4><i class="el-icon-food"></i> 선택된 메뉴 정보</h4>
            </div>
            <div class="details-content">
              <el-row :gutter="$device.mobile ? 0 : 20">
                <el-col :span="$device.mobile ? 24 : 12">
                  <div class="detail-item">
                    <span class="detail-label">메뉴명:</span>
                    <span class="detail-value">{{ bulkCouponForm.selectedMenu.smenuNmLan }}</span>
                  </div>
                </el-col>
                <el-col :span="$device.mobile ? 24 : 12">
                  <div class="detail-item">
                    <span class="detail-label">기본 가격:</span>
                    <span class="detail-value menu-price original-price"
                      >{{ mainVue.formatterPrice(null, null, bulkCouponForm.selectedMenu.priceLan) }}원</span
                    >
                  </div>
                </el-col>
                <el-col :span="$device.mobile ? 24 : 12">
                  <div class="detail-item">
                    <span class="detail-label">할인 금액/율:</span>
                    <span class="detail-value discount-amount">
                      <template v-if="bulkCouponForm.selectedDiscount.discountTp?.val === 'price'">
                        {{
                          mainVue.formatterPrice(
                            null,
                            null,
                            calculateDiscountAmount(
                              bulkCouponForm.selectedMenu.priceLan,
                              bulkCouponForm.selectedDiscount
                            )
                          )
                        }}원
                      </template>
                      <template v-else-if="bulkCouponForm.selectedDiscount.discountTp?.val === 'percent'">
                        {{ bulkCouponForm.selectedDiscount.percente }}%
                      </template>
                    </span>
                  </div>
                </el-col>
                <el-col :span="$device.mobile ? 24 : 12">
                  <div class="detail-item">
                    <span class="detail-label">카테고리:</span>
                    <span class="detail-value">{{ bulkCouponForm.selectedMenu.categorysNm || '-' }}</span>
                  </div>
                </el-col>
                <el-col :span="$device.mobile ? 24 : 12">
                  <div class="detail-item">
                    <span class="detail-label">칼로리:</span>
                    <span class="detail-value">{{
                      bulkCouponForm.selectedMenu.calorie ? bulkCouponForm.selectedMenu.calorie + 'kcal' : '-'
                    }}</span>
                  </div>
                </el-col>
                <el-col :span="24" v-if="bulkCouponForm.selectedMenu.smenuDesc">
                  <div class="detail-item">
                    <span class="detail-label">설명:</span>
                    <span class="detail-value">{{ bulkCouponForm.selectedMenu.smenuDesc }}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>

          <el-form-item label="유효기간" required>
            <el-select v-model="bulkCouponForm.validityPeriod" placeholder="유효기간을 선택하세요" style="width: 100%">
              <el-option
                v-for="period in validityOptions"
                :key="period.value"
                :label="period.label"
                :value="period.value">
              </el-option>
            </el-select>
          </el-form-item>

          <!-- 유효기간 상세 정보 -->
          <div v-if="bulkCouponForm.validityPeriod" class="validity-details-section">
            <div class="details-header">
              <h4><i class="el-icon-time"></i> 유효기간 상세</h4>
            </div>
            <div class="details-content">
              <el-row :gutter="$device.mobile ? 0 : 20">
                <el-col :span="$device.mobile ? 24 : 12">
                  <div class="detail-item">
                    <span class="detail-label">발송일:</span>
                    <span class="detail-value">{{ bulkCouponForm.sendDate }}</span>
                  </div>
                </el-col>
                <el-col :span="$device.mobile ? 24 : 12">
                  <div class="detail-item">
                    <span class="detail-label">만료일:</span>
                    <span class="detail-value expiry-date">{{
                      getExpiryDate(bulkCouponForm.validityPeriod, bulkCouponForm.sendDate)
                    }}</span>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="detail-item">
                    <span class="detail-label">안내:</span>
                    <span class="detail-value validity-notice">
                      <template v-if="bulkCouponForm.validityPeriod === 1">
                        쿠폰은 오늘 23:59까지 사용 가능합니다.
                      </template>
                      <template v-else>
                        쿠폰은 발송일로부터 {{ bulkCouponForm.validityPeriod }}일간 사용 가능하며, 만료일
                        {{ getExpiryDate(bulkCouponForm.validityPeriod, bulkCouponForm.sendDate) }} 23:59까지
                        유효합니다.
                      </template>
                    </span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button :size="size" @click="bulkCouponDialogVisible = false">취소</el-button>
        <el-button
          :size="size"
          type="primary"
          @click="sendBulkCoupon"
          :disabled="
            !bulkCouponForm.selectedDiscount ||
            !bulkCouponForm.validityPeriod ||
            totalMarketingConsentCount <= 0 ||
            (isMenuDiscount(bulkCouponForm.selectedDiscount) && !bulkCouponForm.selectedMenuCd)
          ">
          일괄 쿠폰 발송
        </el-button>
      </div>
    </el-dialog>

    <!-- 요청 문구 편집(V5) — 목록의 「요청 문구」 또는 취향 칸의 링크가 연다 -->
    <RequestPhraseDialog
      :visible.sync="phraseDialogVisible"
      :phrases="phrases"
      :can-save="canEditPhrases"
      @saved="phrases = $event" />
  </div>
</template>

<script>
import { initData } from '@/utils/constants'
import { ALL_ROWS_PAGE_SIZE, SORT_ORDER, pageRows, withPaging } from '@/utils/pagedList'
import mainVueMixin from '@/mixins/mainVueMixin'
import pagedListMixin from '@/mixins/pagedListMixin'
import { util } from '@/mixins/utilMixin'
import { addCalendarDays } from '@/utils/kstDate'
import {
  bulkCouponSendRequestedMessage,
  couponSendDiscountNote,
  couponSendRequestedMessage,
  couponSendableDiscounts,
} from '@/utils/couponSend'
import { permittedRead } from '@/plugins/http/permittedRead'
import { CUSTOMER_IMPORT_ACTION, CUSTOMER_IMPORT_PATH } from '@/utils/customerImport'
import { telText } from '@/utils/telNumber'
import RequestPhraseDialog from '@/components/telInfo/RequestPhraseDialog.vue'
import TelInfoAddressBook from '@/components/telInfo/TelInfoAddressBook.vue'
import {
  TEL_INFO_ACTION,
  TEL_INFO_LIMITS,
  TEL_INFO_PHRASES_API,
  TEL_INFO_TEXT,
  phraseOptionsOf,
  priorLineOf,
  telInfoPatchOf,
} from '@/utils/telInfo'

export default {
  name: 'TelInfoView',
  components: { RequestPhraseDialog, TelInfoAddressBook },
  mixins: [mainVueMixin, pagedListMixin],

  data: function () {
    var data = initData()
    data.url = '/telInfo'

    data.searchForm = this.initSearchForm()
    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()
    // 수정 창을 열 때 받은 고객 — 저장은 이것과 창의 값을 견줘 **바뀐 칸만** 보낸다(`telInfo.telInfoPatchOf`)
    data.loaded = null
    data.limits = TEL_INFO_LIMITS
    data.T = TEL_INFO_TEXT
    // 매장 요청 문구(V5 응답) — 화면 수명 동안 한 번 읽어 취향·라이더 요청 고르기에 같이 쓴다(저장하면 응답으로 바꾼다)
    data.phrases = null
    data.phraseDialogVisible = false
    data.importPath = CUSTOMER_IMPORT_PATH

    // `totalElements` 는 [pagedListMixin] 이 갖는다
    data.totalMarketingConsentCount = 0

    // 쿠폰 발송 관련 데이터
    data.couponDialogVisible = false
    data.selectedCustomer = {}
    data.couponForm = this.initCouponForm()
    // 보낼 수 있는 할인(`couponSend.couponSendableDiscounts`) — 읽기 전·읽는 중·읽기 실패는 null(「없다」와 다르다)
    data.discountList = null
    data.validityOptions = [
      { value: 1, label: '당일' },
      { value: 7, label: '7일' },
      { value: 14, label: '14일' },
      { value: 30, label: '30일' },
    ]

    // 일괄 쿠폰 발송 관련 데이터
    data.bulkCouponDialogVisible = false
    data.bulkCouponForm = this.initCouponForm()

    // 메뉴 선택 관련 데이터
    data.menuList = []

    return data
  },

  computed: {
    // 새 조회·쓰기는 전부 액션 게이트를 지난다 — 서버 권한 행이 나가기 전에는 기능이 숨을 뿐이다(403 = 로그아웃)
    canReadPhrases: function () {
      return this.checkAuthActionAccess(TEL_INFO_ACTION.PHRASE_GET)
    },
    canEditPhrases: function () {
      return this.checkAuthActionAccess(TEL_INFO_ACTION.PHRASE_UP)
    },
    canListAddresses: function () {
      return this.checkAuthActionAccess(TEL_INFO_ACTION.ADDRESS_LIST)
    },
    canEditAddresses: function () {
      return this.checkAuthActionAccess(TEL_INFO_ACTION.ADDRESS_UP)
    },
    canImport: function () {
      return this.checkAuthActionAccess(CUSTOMER_IMPORT_ACTION.LIST)
    },
    /** 기존 고객의 수정 창인가 — 취향·이전 값·주소록은 거기에만 있다 */
    editing: function () {
      return 'U' === this.inputForm.statu
    },
    /** 취향 칸 — 요청 문구를 읽었고 고객 응답에 취향 칸이 있을 때만(옛 서버면 그리지 않는다) */
    showPrefs: function () {
      return this.editing && !!this.phrases && Array.isArray(this.inputForm.prefTags)
    },
    prefOptions: function () {
      return phraseOptionsOf(this.phrases ? this.phrases.kitchen : [], this.inputForm.prefTags)
    },
    priorLine: function () {
      return this.editing ? priorLineOf(this.loaded) : null
    },
    /** 쿠폰 발송 창(단건·일괄)의 할인 고르기 칸 아래 한 줄 — 쿠폰 전용 할인만 보낸다는 것, 없으면 할 일 */
    discountNote: function () {
      return couponSendDiscountNote(this.discountList)
    },
  },

  created: function () {
    this.search()
  },

  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },

  watch: {
    'inputForm.tel': function (newVal, oldVal) {
      if ('' !== newVal && 'I' === this.inputForm.statu) {
        this.chkTel()
      }
    },
  },

  methods: {
    /** 다 친 번호의 표기(유선·070·050·대표번호까지 — `utils/telNumber`) */
    telText,

    /**
     * 검색 조건 초기화 — 페이징·정렬 축은 [withPaging] 이 붙인다.
     *
     * 기본 정렬은 표의 `:default-sort` 와 **같은 축**을 서버에 보낸다. 지금 서버 기본값도 같은
     * `lastTelDate` 내림차순이라 보내지 않아도 순서는 같지만, 머리글의 화살표는 요청이 무엇을
     * 물었는지와 무관하게 그려진다 — 축을 적어 보내야 서버 기본값이 바뀌는 날 화살표와 실제 순서가
     * 갈리지 않는다. 예전에는 클라이언트 정렬이 그 한 장을 다시 늘어놓아 이 어긋남이 가려져 있었다.
     */
    initSearchForm: function () {
      return Object.assign(
        withPaging({
          tel: '',
          name: '',
          useYn: 'Y',
        }),
        { sortProp: 'lastTelDate', sortOrder: SORT_ORDER.DESC }
      )
    },

    /**
     * 입력폼 초기화 — 주소 칸(`addr`·`addrDtl`)은 두지 않는다. 고객 주소의 정본은 주소록(`tbl_tel_info_address`)이고 그 두 칸은
     * 고객 기록 처리기가 배달 주문 때 쓰는 **거울**이라, 손으로 고치면 주소록과 갈린다(목록 조회도 빈 값과 없음을 같게 본다).
     */
    initInputForm: function () {
      return {
        statu: 'I',
        title: '',
        seq: 0,
        tel: '',
        name: '',
        lastShopMemo: '',
        telOrderCnt: 0,
        orderCnt: 0,
        useYn: 'Y',
        marketingAgree: false,
        marketingAgreeDate: null,
      }
    },

    // 오류 메세지 초기화
    initFormError: function () {
      return {
        tel: '',
        name: '',
        useYn: '',
        lastShopMemo: '',
        prefTags: '',
      }
    },

    // 쿠폰 폼 초기화
    initCouponForm: function () {
      return {
        selectedDiscount: null,
        selectedDiscountCd: null,
        validityPeriod: null,
        selectedMenu: null,
        selectedMenuCd: null,
        sendDate: null,
      }
    },

    /**
     * 「주문 횟수」 칸의 표시 — 값은 [search] 가 행마다 만든 합(`totalOrderCntDesc`) 하나뿐이다.
     *
     * 열의 `prop` 은 **서버 정렬 축**(`totalOrderCnt`)이라 셀이 그것을 그대로 그리면 빈 칸이 된다.
     * 합을 여기서 다시 더하지 않는 이유도 같다 — 같은 파생값을 두 곳에서 만들지 않는다(쿠폰 팝업의
     * 「주문 횟수」도 그 필드를 읽는다).
     */
    formatTotalOrderCnt: function (row) {
      return row.totalOrderCntDesc
    },

    // 그리드 선택 이벤트
    handleRowClick: function (val) {
      if (null != val) {
        this.btn.upDisabled = false
      }
      this.selectData = val
    },

    // 체크 박스 체크 이벤트
    handleRowChecked: function (selection, row) {
      if (selection.length > 0) {
        this.btn.delDisabled = false
      } else {
        this.btn.delDisabled = true
      }

      this.checkedData = []

      for (var i = 0, len = selection.length; i < len; i++) {
        this.checkedData[this.checkedData.length] = selection[i].seq
      }
    },

    // 추가
    add: function () {
      this.inputForm = this.initInputForm()
      this.inputForm.title = this.$t('고객정보 추가')

      this.formError = this.initFormError()

      this.dialogFormVisible = true
      this.btn.saveDisabled = false
    },

    // 메뉴 클릭해서 수정
    clickUp: function (row) {
      this.handleRowClick(row)
      this.up()
    },

    /**
     * 수정 — 받은 고객을 `loaded` 로 남기고 창에는 그 **사본**을 앉힌다. 저장은 둘을 견줘 바뀐 칸만 보낸다([save]).
     */
    up: function () {
      this.mainVue.$axios.get(
        this.url + '/' + this.selectData.seq,
        function (result) {
          this.loaded = Object.freeze(Object.assign({}, result))
          this.formError = this.initFormError()

          this.inputForm = Object.assign(
            {},
            result,
            Array.isArray(result.prefTags) ? { prefTags: result.prefTags.slice() } : null,
            {
              statu: 'U',
              title: this.$t('고객정보 수정'),
              // marketingAgreeDate가 null이 아니면 동의, null이면 미동의
              marketingAgree: !!result.marketingAgreeDate,
            }
          )

          this.dialogFormVisible = true
          this.btn.saveDisabled = false
          // 취향 고르기의 선택지 — 창을 열 때만 읽는다(목록 진입에는 새 조회가 없다)
          this.loadPhrases()
        }.bind(this),
        true
      )
    },

    /**
     * 매장 요청 문구를 한 번 읽는다(V5 — `storeCd` 없음 = 로그인 매장). 액션이 없으면 부르지 않는다. 읽었으면 다시 부르지 않고,
     * 못 읽었으면 취향 칸을 그리지 않는다(다음에 창을 열 때 다시 읽는다).
     *
     * @returns {Promise<boolean>} 문구가 있는가
     */
    loadPhrases: async function () {
      if (this.phrases) return true
      if (!this.canReadPhrases) return false

      try {
        const read = await permittedRead({
          action: TEL_INFO_ACTION.PHRASE_GET,
          url: TEL_INFO_PHRASES_API,
          showLoading: false,
          showErrorMessage: false,
        })
        if (read.allowed && read.data) this.phrases = read.data
      } catch (error) {
        // 부가 조회다 — 취향 칸을 그리지 않는 것이 대체 동작이다
      }

      return !!this.phrases
    },

    /** 「요청 문구」 — 문구를 읽고 창을 연다. 못 읽었으면 그렇게 말한다 */
    openPhraseDialog: async function () {
      if (await this.loadPhrases()) {
        this.phraseDialogVisible = true
        return
      }
      this.mainVue.$message({ type: 'error', message: this.$t(this.T.phrasesLoadFailed) })
    },

    // 마케팅 동의 여부 변경
    onMarketingAgreeChange: function (value) {
      if (value) {
        // 동의: 현재 날짜 설정 (yyyy-MM-dd HH:mm:ss 형식)
        this.inputForm.marketingAgreeDate = util.getNow('yyyy-MM-dd HH:mm:ss')
      } else {
        // 미동의: null로 설정
        this.inputForm.marketingAgreeDate = null
      }
    },

    // 조회
    search: function () {
      this.mainVue.$axios.search(
        this.url,
        this.searchQuery(),
        function (result) {
          this.applyPage(result)
          this.tableData.forEach((el) => {
            el.totalOrderCntDesc = el.orderCnt + el.telOrderCnt
            // marketingAgreeDate가 null이 아니면 동의, null이면 미동의로 처리
            // 서버에서 받은 marketingAgreeDate 값을 그대로 사용
          })
          this.totalMarketingConsentCount = (result && result.totalMarketingConsentCount) || 0

          this.btn.addDisabled = false
          this.btn.upDisabled = true
          this.btn.delDisabled = true

          this.inputForm = this.initInputForm()
          this.formError = this.initFormError()
        }.bind(this),
        false
      )
    },

    // 삭제
    del: function () {
      this.$confirm(this.$t('{0}를 삭제 하시겠습니까?', [this.$t('고객 정보')]), this.mainVue.appMsg.systemAlterTitle, {
        confirmButtonText: this.$t('삭제'),
        cancelButtonText: this.$t('취소'),
        type: 'info',
      })
        .then(
          function () {
            this.mainVue.$axios.del(
              this.url + '/' + this.checkedData.join(','),
              function (result) {
                this.mainVue.$message({ type: 'success', message: this.$t('삭제 성공') })
                this.search()
              }.bind(this),
              true
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('삭제 취소') })
          }.bind(this)
        )
    },

    /**
     * 저장 — 추가는 폼 그대로(`POST /telInfo`), 수정은 **화면에서 바뀐 칸만**(`PUT /telInfo/{seq}` — 서버가 키 있는 칸만 바꾼다,
     * appserver AP1). 받은 전체를 되돌려 보내면 그 사이 주문이 쓴 거울 주소·주문 수를 옛 값으로 덮는다. 바뀐 칸이 없으면 요청
     * 없이 닫는다. 필드 오류(`errorsMessage`)는 지금처럼 그 칸에 앉는다.
     */
    save: function () {
      this.formError = this.initFormError()

      if ('I' === this.inputForm.statu) {
        this.mainVue.$axios.add(
          this.url,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('등록 성공') })
            this.dialogFormVisible = false
            this.search()
          }.bind(this),
          true
        )
        return
      }

      const patch = telInfoPatchOf(this.loaded, this.inputForm)
      if (Object.keys(patch).length === 0) {
        this.dialogFormVisible = false
        return
      }

      this.mainVue.$axios.up(
        this.url + '/' + this.inputForm.seq,
        patch,
        this.formError,
        function (result) {
          this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
          this.dialogFormVisible = false
          this.search()
        }.bind(this),
        true
      )
    },

    // 핸드폰 번호 체크
    chkTel: function () {
      this.mainVue.$axios.patchNonLoading(
        this.url + '/chk/' + this.inputForm.tel,
        null,
        null,
        function (result) {
          if ('' === result) {
            this.formError.tel = ''
            this.btn.saveDisabled = false
          } else {
            this.formError.tel = this.$t('이미 사용중인 {0}입니다.', [this.$t('핸드폰 번호')])
            this.btn.saveDisabled = true
          }
        }.bind(this),
        false
      )
    },

    // 쿠폰 발송 팝업 열기
    openCouponDialog: function (customerData) {
      this.selectedCustomer = customerData
      this.couponForm = this.initCouponForm()
      this.couponForm.sendDate = util.getNow('yyyy-MM-dd')
      this.fetchDiscountList()
      this.fetchMenuList()
      this.couponDialogVisible = true
    },

    // 할인 목록 조회 — 쿠폰 창을 열 때마다 다시 읽는다. 읽는 동안과 읽기 실패는 「모름」(null)이다: 앞서 읽은 목록(특히 빈
    // 목록의 「쿠폰 전용 할인이 없다」)을 지금의 사실로 남기지 않는다. 두 호출부가 바로 앞에서 폼을 새로 만들어 지킬 선택이 없다
    fetchDiscountList: function () {
      this.discountList = null

      const searchForm = {
        discountNm: '',
        useYn: 'Y',
      }

      this.mainVue.$axios.search(
        '/discount/store',
        searchForm,
        function (result) {
          this.discountList = couponSendableDiscounts(result)
        }.bind(this),
        false
      )
    },

    // 메뉴 목록 조회 — 쿠폰 발송 팝업의 메뉴 셀렉트용이라 **한 매장 전량**이 필요하다
    fetchMenuList: function () {
      const searchForm = {
        categoryCd: null,
        smenuNm: '',
        useYn: 'Y',
        // 셀렉트는 다음 장으로 넘어갈 수단이 없으므로 **전량**이다([ALL_ROWS_PAGE_SIZE])
        pageSize: ALL_ROWS_PAGE_SIZE,
      }

      this.mainVue.$axios.search(
        '/smenu/store',
        searchForm,
        function (result) {
          // 봉투를 푸는 일은 [pageRows] 한 곳이 한다 — 배열을 가정하면 봉투가 온 날 `filter` 가 터진다
          this.menuList = pageRows(result).filter((menu) => menu.useYn === 'Y')
        }.bind(this),
        false
      )
    },

    // 메뉴 할인 여부 판별
    isMenuDiscount: function (discount) {
      if (!discount || !discount.discountTarget) {
        return false
      }
      // 할인 대상이 메뉴(MENU) 또는 아이템(ITEM)인 경우 메뉴 할인으로 판별
      const targetVal = discount.discountTarget.val
      return targetVal === 'menu'
    },

    // 일괄 쿠폰 발송 팝업 열기
    openBulkCouponDialog: function () {
      this.bulkCouponForm = this.initCouponForm()
      this.bulkCouponForm.sendDate = util.getNow('yyyy-MM-dd')
      this.fetchDiscountList()
      this.fetchMenuList()
      this.bulkCouponDialogVisible = true
    },

    /**
     * 쿠폰 발송 요청 — 헬퍼의 결과 값(`{ ok }`)을 그대로 돌려준다. 단건·일괄이 같이 쓴다.
     *
     * 실패는 인터셉터가 이미 서버 문장으로 알렸고(예: 409 「발급 건수 한도가 소진된 할인입니다.」) 헬퍼가 값으로 끝낸다
     * (`plugins/http/legacyHelpers` — 다시 던지지 않는다, R-K2 D2). 창과 선택은 호출부가 그대로 둔다: 다른 쿠폰을 고르거나
     * 닫는 것은 사람이 한다.
     *
     * **HTTP 상태만 읽는다** — 2xx 면 보냈다. 서버는 발급하지 못한 요청을 2xx 로 접지 않는다(요청 검증 400 · 발급 실패 500 ·
     * 한도 409 — appserver 가 종전 「200 + `success:false`」를 상태 코드로 바꿨다, 리뷰 M3, appserver 선배포). 본문의
     * `success` 를 여기서 다시 판정하지 않는다 — 판정이 두 곳이 된다.
     *
     * @returns {Promise<{ok: boolean}>}
     */
    requestSendCoupon: function (couponData) {
      return this.mainVue.$axios.post(this.url + '/sendCoupon', couponData)
    },

    /** 발송 확인창 — 「발송」이면 `true`, 취소면 취소 안내 뒤 `false`. 요청 실패를 취소로 말하지 않는다 */
    confirmSendCoupon: async function (message, title, cancelledMessage) {
      try {
        await this.mainVue.$confirm(message, title, {
          confirmButtonText: this.$t('발송'),
          cancelButtonText: this.$t('취소'),
          type: 'info',
        })

        return true
      } catch (cancelled) {
        this.mainVue.$message({ type: 'info', message: cancelledMessage })

        return false
      }
    },

    // 쿠폰 발송
    sendCoupon: async function () {
      if (!this.couponForm.selectedDiscount || !this.couponForm.validityPeriod) {
        this.mainVue.$message({ type: 'warning', message: this.$t('쿠폰과 유효기간을 모두 선택해주세요.') })
        return
      }

      // 메뉴 할인인 경우 메뉴 선택 여부 검증
      if (this.isMenuDiscount(this.couponForm.selectedDiscount) && !this.couponForm.selectedMenuCd) {
        this.mainVue.$message({ type: 'warning', message: this.$t('메뉴 할인의 경우 적용할 메뉴를 선택해주세요.') })
        return
      }

      const confirmed = await this.confirmSendCoupon(
        `${this.selectedCustomer.name || this.$t('고객')}님에게 쿠폰을 발송하시겠습니까?`,
        this.$t('쿠폰 발송 확인'),
        this.$t('쿠폰 발송을 취소했습니다.')
      )
      if (!confirmed) return

      // API 호출을 위한 데이터 준비
      const couponData = {
        customerTel: this.selectedCustomer.tel,
        customerName: this.selectedCustomer.name,
        discountCd: this.couponForm.selectedDiscount.discountCd,
        discountName: this.couponForm.selectedDiscount.discountNm,
        discountType: this.couponForm.selectedDiscount.discountTp.val,
        discountValue:
          this.couponForm.selectedDiscount.discountTp.val === 'price'
            ? this.couponForm.selectedDiscount.price
            : this.couponForm.selectedDiscount.percente,
        validityPeriod: this.couponForm.validityPeriod,
        sendDate: this.couponForm.sendDate,
      }

      // 메뉴 할인인 경우 메뉴 정보 추가
      if (this.isMenuDiscount(this.couponForm.selectedDiscount) && this.couponForm.selectedMenu) {
        couponData.menuCd = this.couponForm.selectedMenu.smenuCd
        couponData.menuName = this.couponForm.selectedMenu.smenuNm
      }

      if (!(await this.requestSendCoupon(couponData)).ok) return

      // 2xx 는 「발송을 맡겼다」다 — 알림톡은 뒤에서 나가고 실패할 수 있다(R-L V1-8, `utils/couponSend`)
      this.mainVue.$message({
        type: 'success',
        message: couponSendRequestedMessage(this.selectedCustomer.name || this.$t('고객')),
      })
      this.couponDialogVisible = false
    },

    // 일괄 쿠폰 발송
    sendBulkCoupon: async function () {
      if (!this.bulkCouponForm.selectedDiscount || !this.bulkCouponForm.validityPeriod) {
        this.mainVue.$message({ type: 'warning', message: this.$t('쿠폰과 유효기간을 모두 선택해주세요.') })
        return
      }

      // 메뉴 할인인 경우 메뉴 선택 여부 검증
      if (this.isMenuDiscount(this.bulkCouponForm.selectedDiscount) && !this.bulkCouponForm.selectedMenuCd) {
        this.mainVue.$message({ type: 'warning', message: this.$t('메뉴 할인의 경우 적용할 메뉴를 선택해주세요.') })
        return
      }

      const confirmed = await this.confirmSendCoupon(
        `마케팅 동의한 ${this.totalMarketingConsentCount}명의 고객에게 쿠폰을 일괄 발송하시겠습니까?`,
        this.$t('일괄 쿠폰 발송 확인'),
        this.$t('일괄 쿠폰 발송을 취소했습니다.')
      )
      if (!confirmed) return

      // API 호출을 위한 데이터 준비
      const bulkCouponData = {
        discountCd: this.bulkCouponForm.selectedDiscount.discountCd,
        discountName: this.bulkCouponForm.selectedDiscount.discountNm,
        discountType: this.bulkCouponForm.selectedDiscount.discountTp.val,
        discountValue:
          this.bulkCouponForm.selectedDiscount.discountTp.val === 'price'
            ? this.bulkCouponForm.selectedDiscount.price
            : this.bulkCouponForm.selectedDiscount.percente,
        validityPeriod: this.bulkCouponForm.validityPeriod,
        sendDate: this.bulkCouponForm.sendDate,
        isBulkSend: true, // 일괄 발송 구분
      }

      // 메뉴 할인인 경우 메뉴 정보 추가
      if (this.isMenuDiscount(this.bulkCouponForm.selectedDiscount) && this.bulkCouponForm.selectedMenu) {
        bulkCouponData.menuCd = this.bulkCouponForm.selectedMenu.smenuCd
        bulkCouponData.menuName = this.bulkCouponForm.selectedMenu.smenuNm
      }

      if (!(await this.requestSendCoupon(bulkCouponData)).ok) return

      this.mainVue.$message({
        type: 'success',
        message: bulkCouponSendRequestedMessage(this.totalMarketingConsentCount),
      })
      this.bulkCouponDialogVisible = false
    },

    // 할인 선택 변경 이벤트 (개별 쿠폰)
    onDiscountChange: function (discountCd) {
      this.couponForm.selectedDiscount =
        this.discountList.find((discount) => discount.discountCd === discountCd) || null
      // 할인이 변경되면 메뉴 선택 초기화
      this.couponForm.selectedMenu = null
      this.couponForm.selectedMenuCd = null
    },

    // 메뉴 선택 변경 이벤트 (개별 쿠폰)
    onMenuChange: function (menuCd) {
      this.couponForm.selectedMenu = this.menuList.find((menu) => menu.smenuCd === menuCd) || null
    },

    // 할인 선택 변경 이벤트 (일괄 쿠폰)
    onBulkDiscountChange: function (discountCd) {
      this.bulkCouponForm.selectedDiscount =
        this.discountList.find((discount) => discount.discountCd === discountCd) || null
      // 할인이 변경되면 메뉴 선택 초기화
      this.bulkCouponForm.selectedMenu = null
      this.bulkCouponForm.selectedMenuCd = null
    },

    // 메뉴 선택 변경 이벤트 (일괄 쿠폰)
    onBulkMenuChange: function (menuCd) {
      this.bulkCouponForm.selectedMenu = this.menuList.find((menu) => menu.smenuCd === menuCd) || null
    },

    /**
     * 만료일(마지막 날) — 당일(1일)이면 발송일, n일이면 발송일 + (n − 1)일. 서버 `expiredDate` 는 그 다음 날 00:00 KST 다.
     * 날짜 셈은 달력 날짜로 한다(`kstDate.addCalendarDays`) — `new Date('YYYY-MM-DD')`(UTC 자정)를 로컬 칸으로 읽으면 KST 가
     * 아닌 브라우저에서 하루 모자란다(K4·K5 O-4). 발송일이 없으면 KST 오늘이다.
     */
    getExpiryDate: function (validityPeriod, sendDate) {
      if (!validityPeriod) return ''

      return addCalendarDays(sendDate || util.getNow('yyyy-MM-dd'), validityPeriod - 1)
    },

    // 할인 금액 계산
    calculateDiscountAmount: function (originalPrice, discount) {
      if (!discount || !originalPrice) return 0

      if (discount.discountTp?.val === 'price') {
        // 고정 금액 할인
        return Math.min(discount.price || 0, originalPrice)
      } else if (discount.discountTp?.val === 'percent') {
        // 퍼센트 할인
        return Math.floor((originalPrice * (discount.percente || 0)) / 100)
      }

      return 0
    },
  },
}
</script>

<style scoped>
.show_cd {
  font-weight: bold;
  color: #333;
}

.tel-info__notice {
  margin: 4px 0 0;
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}

.tel-info__prior {
  color: #606266;
}

.tel-info__prefs {
  width: 100%;
}

.coupon-dialog-content {
  padding: 10px 0;
}

.customer-info-section {
  background-color: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 20px;
  margin-bottom: 20px;
}

.customer-info-section h4 {
  margin: 0 0 15px 0;
  color: #303133;
  font-size: 16px;
  font-weight: 600;
}

.customer-details p {
  margin: 0 0 8px 0;
  font-weight: 600;
  color: #606266;
}

.customer-details ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.customer-details li {
  margin: 5px 0;
  padding: 5px 0;
  color: #303133;
}

.customer-details li strong {
  color: #409eff;
}

/* 쿠폰 상세 정보 섹션 스타일 */
.coupon-details-section,
.menu-details-section,
.validity-details-section {
  background-color: #f9f9f9;
  border: 1px solid #e1e4e8;
  border-radius: 6px;
  padding: 16px;
  margin: 15px 0;
}

.details-header {
  margin-bottom: 12px;
}

.details-header h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #24292e;
  display: flex;
  align-items: center;
}

.details-header h4 i {
  margin-right: 8px;
  color: #409eff;
}

.details-content {
  margin-top: 10px;
}

.detail-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  padding: 4px 0;
}

.detail-label {
  font-weight: 600;
  color: #586069;
  min-width: 80px;
  margin-right: 12px;
}

.detail-value {
  color: #24292e;
  font-weight: 500;
  flex: 1;
}

.discount-amount {
  color: #d73a49;
  font-weight: 700;
  font-size: 16px;
}

.menu-price {
  color: #28a745;
  font-weight: 700;
}

.original-price {
  color: #24292e;
  font-weight: 700;
}

.discounted-price {
  color: #dc3545;
  font-weight: 700;
  font-size: 16px;
}

.expiry-date {
  color: #e36209;
  font-weight: 700;
}

.validity-notice {
  color: #6a737d;
  font-size: 12px;
  line-height: 1.4;
  background-color: #fff8dc;
  padding: 8px;
  border-radius: 4px;
  border-left: 3px solid #f9c513;
}

/* 모바일 최적화 */
@media (max-width: 768px) {
  .coupon-dialog-content {
    padding: 5px 0;
  }

  .customer-info-section,
  .coupon-details-section,
  .menu-details-section,
  .validity-details-section {
    padding: 12px;
    margin: 10px 0;
  }

  .detail-item {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 12px;
    padding: 8px 0;
  }

  .detail-label {
    min-width: auto;
    margin-right: 0;
    margin-bottom: 4px;
    font-size: 13px;
  }

  .detail-value {
    font-size: 14px;
    line-height: 1.3;
  }

  .discount-amount,
  .menu-price,
  .expiry-date {
    font-size: 15px;
  }

  .validity-notice {
    font-size: 11px;
    padding: 6px;
  }

  .details-header h4 {
    font-size: 13px;
  }

  .customer-info-section h4 {
    font-size: 15px;
  }

  .customer-details li {
    margin: 3px 0;
    padding: 3px 0;
    font-size: 13px;
  }
}
</style>
